(() => {
    window.Dashboard = window.Dashboard || {};
    window.Dashboard.Models = window.Dashboard.Models || {};
    window.Dashboard.Models.Order = window.Dashboard.Models.Order || {};

    class Order {
        Voucher = null;
        Vouchers = [];
        CreditCardPayment = null;
        CardPaymentIsReversible = false;
        VoucherIsReversible = false;
        ChannelId;
        PaymentType;
        PaymentMethodAsString;
        AcceptedMethod;
        IsCollect;
        DeliveryAreaName;

        constructor(model) {
            const order = Object.assign(this, model);
            if (model.Voucher) {
                this.Vouchers.push(model.Voucher);
            }
            return order;
        }

        creditCardPaymentReversed() {
            if (!this.CreditCardPayment) {
                return false;
            }

            // 3 == CreditCardPaymentState.Reversed. See CreditCardPaymentState.cs
            return self.CreditCardPayment.StateId === Dashboard.CreditCardPaymentStates.Reversed;
        };

        voucherRefunded() {
            if (!this.Voucher) {
                return false;
            }

            // 3 == VoucherStatus.Reversed. See VoucherStatus.cs
            return this.Voucher.Status === Dashboard.VoucherStatus.Reversed;
        };

        /**
         * Returns true if there is a card payment or voucher on the order.
         * @returns {boolean}
         */
        hasPaymentDetails() {
            return !!this.CreditCardPayment || !!this.Voucher;
        }

        canRefundOrder() {
            return this.CardPaymentIsReversible
                || this.VoucherIsReversible;
        }
    }

    window.Order = Order;
    window.Dashboard.Models.Order = Order;
})();
